<template>
  <div>
    <address-search />
  </div>
</template>

<script>
  import AddressSearch from '@/components/recherche/rechercheSearch/MeiliSearchList.vue'

  export default {
    components: {
      AddressSearch
    }
  }
</script>
